module.exports = __webpack_public_path__ + "img/i_banner_vdzls.163b90ac.jpg";